<template functional>
  <span
    :aria-hidden="props.decorative"
    :aria-label="props.title"
    :class="[data.class, data.staticClass]"
    v-bind="data.attrs"
    class="material-design-icon access-point-off-icon"
    role="img"
    v-on="listeners">
    <svg
      :fill="props.fillColor"
      :width="props.size"
      :height="props.size"
      :transform="'rotate(' + props.rotate + ')'"
      class="material-design-icon__svg"
      viewBox="0 0 20 20">
      <path
        d="M17.5002 2.5H2.50016C1.57516 2.5 0.833496 3.24167 0.833496 4.16667V15.8333C0.833496 16.7583 1.57516 17.5 2.50016 17.5H17.5002C18.4252 17.5 19.1668 16.7583 19.1668 15.8333V4.16667C19.1668 3.24167 18.4252 2.5 17.5002 2.5ZM17.5002 15.85H2.50016V4.15H17.5002V15.85ZM8.3335 10H6.66683L10.0002 6.66667L13.3335 10H11.6668V13.3333H8.3335V10Z"
      />
    </svg>
  </span>
</template>


<script>
export default {
  name: "BecomeSpeaker",
  props: {
    title: {
      type: String,
      default: ""
    },
    decorative: {
      type: Boolean,
      default: false
    },
    fillColor: {
      type: String,
      default: "#F8F8F8"
    },
    size: {
      type: Number,
      default: 20
    },
    rotate: {
      type: Number,
      default: 0
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/icons/BecomeSpeaker.vue